module.exports = __webpack_public_path__ + "static/media/office-floor-plan.36d583aa.png";